import { TOUR_IDS } from "@demandproai/shared";
import { useOptionalTourContext } from "../contexts/TourContext";

// Three of the case list tour's stops are anchored to the sample row, so it has
// to be on the page from before the tour can start until after it has ended.
// Without a provider there is no tour to serve, so there is no sample either.
const useSampleCase = () => {
   const tour = useOptionalTourContext();

   const hasSampleCase = Boolean(
      tour &&
         (tour.isTourPending(TOUR_IDS.CASE_LIST) || tour.requestedTourId === TOUR_IDS.CASE_LIST)
   );

   return { hasSampleCase };
};

export default useSampleCase;
